import {
  EnvironmentConfig,
  environmentDefaultsEvernorth,
  featureFlagDefaults,
  oidcEvernorthDefault,
} from '@cigna/chcp/shared/environment-util';

export const environment: EnvironmentConfig = {
  ...environmentDefaultsEvernorth,
  oidc: {
    ...oidcEvernorthDefault,
    secureUris: [
      'https://p-evernorth-provider.digitaledge.cigna.com',
      'https://p-gsg.digitaledge.cigna.com',
      '/prv/secure',
    ],
  },
  redirect: {
    crossOrigin: {
      domain: 'https://cignaforhcp.cigna.com',
    },
  },
  api: {
    proxy: {
      headers: {
        accept: '*/*',
        content_type: 'application/json',
      },
    },
    gateways: {
      cdn: 'https://static.evernorth.com/',
      resourceContent: 'https://p-digital-static.digitaledge.cigna.com/',
      secureApi: 'https://p-evernorth-provider.digitaledge.cigna.com',
      publicApi: 'https://p-evernorth-provider.digitaledge.cigna.com/public',
      gsgPublicApi: 'https://p-gsg.digitaledge.cigna.com/public',
      gsgSecureApi: 'https://p-gsg.digitaledge.cigna.com',
      graphql:
        'https://p-evernorth-provider.digitaledge.cigna.com/apollo-graphql',
    },
    searchIndex: 'prod',
    salesDemo: false,
  },
  features: {
    ...featureFlagDefaults,
    nextRelease: false,
    patientEnhPower: false,
    messageCenterPrefWAM: false,
    emailVerifyPopup: false,
    claim360GA: false,
    mobilePhoneVerification: false,
    allowTempIdPassAddition: false,
    gqlBrn: false,
    onetrust: false,
    enhancedCOCE: false,
    enablePCM: false,
    messageCenterGA: false,
    correspondenceCenter: false,
    eftMasking: false,
  },
  disabledRoutes: [],
};
